import $ from "jquery";

$(document).ready(function () {
    document.arrive('.brand-column-content-container', {existing: true}, function () {
        $(this)
            .unbind("click")
            .bind("click", function () {
                if ($(this).hasClass("active")) {
                    $('.brand-column-content-container').removeClass('active');
                } else {
                    $('.brand-column-content-container').removeClass('active');
                    $(this).toggleClass("active");
                }
            });
        $(this).find('.btn-cta').click(function(e) {
            e.stopPropagation();
        });
    });
});

function fixMobileSectionsFp() {
    let $b_sections = $('.block-brand-columns');
    if ($b_sections.length) {
        if ($(window).width() < 992) {
            let $b_columns = $('.brand-column');
            let last_section = $b_sections.hasClass('last');
            let id = $($b_sections[0]).attr('id').slice(0, -1);
            let init_last_section = last_section;
            let html = '';

            if ($(window).width() >= 768) {
                // Tablet
            } else {
                // Phone
            }
            // Tablet and Phones
            $b_columns.each(function(index, el) {
                if(index % 2 === 0) {
                    html += openSection(id+index);
                    let section_content = $('<div/>');
                    section_content.append($(el).clone());
                    init_last_section = false;
                    let $next = $($b_columns[index+1]);
                    if ($next.length) {
                        section_content.append($next.clone());
                        init_last_section = true;
                    }
                    html += section_content.html();
                    html += closeSection();
                }
            });

            let $insert_pos = $($b_sections[0]).prev('section');
            $b_sections.remove();
            $insert_pos.after($('<div/>').html(html).contents());
            // fix last section
            if (last_section) {
                let $last = $('.block-brand-columns').last();
                $last.addClass('last');
                if (!init_last_section) {
                    $last.removeClass('section fp-auto-height');
                }
            }
        }
    }
}

function openSection(id) {
    return '<section class="block-brand-columns section fp-auto-height" id="'+id+'"><div class="block-brand-columns-container srg-container-fullwidth"><div class="row">';
}

function closeSection() {
    return '</div></div></section>';
}

export default {
    fixMobileSectionsFp
}